import type { AnswerValue, QuestionnaireAnswer, QuestionnaireItem } from "@ferrivia/api-contract";

export type AnswerMap = Readonly<Record<string, AnswerValue>>;
export type ItemFields = Readonly<Record<string, AnswerValue>>;

export function toAnswerMap(answers: readonly QuestionnaireAnswer[]): AnswerMap {
  return Object.fromEntries(answers.map((answer) => [answer.questionKey, answer.value]));
}

export function itemsFor(items: readonly QuestionnaireItem[], groupKey: string): ItemFields[] {
  return items
    .filter((item) => item.questionKey === groupKey)
    .sort((a, b) => a.itemIndex - b.itemIndex)
    .map((item) => Object.fromEntries(item.fields.map((field) => [field.fieldKey, field.value])));
}

export function isAnswered(value: AnswerValue | undefined): value is AnswerValue {
  if (!value) {
    return false;
  }
  if (value.kind === "text") {
    return value.value.trim() !== "";
  }
  if (value.kind === "multi_choice") {
    return value.value.length > 0;
  }
  return true;
}

export function isTrue(answers: AnswerMap, key: string): boolean {
  const value = answers[key];
  return value?.kind === "boolean" && value.value;
}
